export default __webpack_public_path__ + "static/media/women-7.729b16f1.jpg";